import { FiUser, FiPhone, FiMessageSquare } from 'react-icons/fi';
import { CustomerHeader } from './CustomerHeader';
import { CustomerDetails } from './CustomerDetails';
import { CallLogs } from './CallLogs';
import { TextLogs } from './TextLogs';
import { CustomerModalProps } from '@/types/TCRMLead';
import { useState } from 'react';

export const CustomerModal: React.FC<CustomerModalProps> = ({ customer, isOpen, onClose }) => {
	const [activeTab, setActiveTab] = useState('details');

	if (!customer) {
		return null;
	}

	const handleTabChange = (key: string) => {
		setActiveTab(key);
	};

	const tabs = [
		{ key: 'details', label: 'Details', icon: FiUser },
		{ key: 'calls', label: 'Call Logs & Intake Forms', icon: FiPhone },
		{ key: 'texts', label: 'Text Logs', icon: FiMessageSquare },
	];

	const renderTabContent = () => {
		switch (activeTab) {
			case 'details':
				return <CustomerDetails customer={customer} agentId={customer.agentId} />;
			case 'calls':
				return <CallLogs customer={customer} clientID={customer.agentId} />;
			case 'texts':
				return <TextLogs customer={customer} clientID={customer.agentId} />;
			default:
				return <CustomerDetails customer={customer} agentId={customer.agentId} />;
		}
	};

	if (!isOpen) {
		return null;
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center">
			<div className="fixed inset-0 bg-black bg-opacity-50" onClick={onClose} />
			<div className="relative bg-white rounded-lg shadow-xl w-[90vw] h-[85vh] max-w-7xl overflow-hidden">
				<div className="h-full flex flex-col">
					<CustomerHeader customer={customer} onClose={onClose} />

					<div className="flex-1 overflow-hidden">
						<div className="border-b bg-gray-50">
							<div className="flex">
								{tabs.map((tab) => {
									const IconComponent = tab.icon;
									return (
										<button
											key={tab.key}
											onClick={() => handleTabChange(tab.key)}
											className={`flex items-center gap-2 px-6 py-4 border-b-2 font-medium text-sm transition-colors ${
												activeTab === tab.key
													? 'border-blue-500 text-blue-600 bg-white'
													: 'border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-100'
											}`}
										>
											<IconComponent className="w-4 h-4" />
											{tab.label}
										</button>
									);
								})}
							</div>
						</div>

						<div className="p-6 h-full overflow-y-auto" style={{ height: 'calc(85vh - 200px)' }}>
							{renderTabContent()}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
